import React from 'react'
import {Trans, useTranslation} from 'react-i18next'
import {Card, Typography} from 'antd'
import classNames from 'classnames'
import {IS_SIDER_COLLAPSED_KEY} from '@/constants'
import {useScreenType, useLocalStorageBoolean} from '@/hooks'
import EsgImpactImg from '~/assets/img/digital-receipts/esg_impact_v1.svg'
import {DigitalReceiptsButtons} from '../'

import styles from './styles.scss'

export const EsgImpact = () => {
    const {t} = useTranslation()
    const isCollapsed = useLocalStorageBoolean(IS_SIDER_COLLAPSED_KEY)
    const {isTablet, isDesktop, isMobile} = useScreenType()
    const titleLevel = isDesktop ? 1 : 3

    const containerClass = classNames(styles.root, {
        [styles.mobileLayout]: isMobile || (isTablet && !isCollapsed),
        [styles.desktopLayout]: isDesktop || (isTablet && isCollapsed)
    })

    return (
        <Card>
            <div className={containerClass}>
                <div className={styles.content}>
                    <Typography.Title level={titleLevel} className={styles.title}>
                        <Trans
                            i18nKey='EsgImpact.title'
                            components={{
                                green: <span className={styles.green} />
                            }}
                        />
                    </Typography.Title>{' '}
                    <Typography.Paragraph>{t('EsgImpact.description')}</Typography.Paragraph>
                    <ul className={styles.list}>
                        <li>{t('EsgImpact.item1')}</li>
                        <li>{t('EsgImpact.item2')}</li>
                        <li>{t('EsgImpact.item3')}</li>
                    </ul>
                    <DigitalReceiptsButtons className={styles.buttons} />
                </div>
                <div className={styles.imageContainer}>
                    <img src={EsgImpactImg} alt={t('EsgImpact.alt')} />
                </div>
            </div>
        </Card>
    )
}
